import script from "./TheInfoDrawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheInfoDrawer.vue?vue&type=script&lang=ts&setup=true"

import "./TheInfoDrawer.vue?vue&type=style&index=0&id=2a164b44&lang=sass"

const __exports__ = script;

export default __exports__